<app-navbar></app-navbar>

<div *ngIf="!loading" class="dashboard">
  <div id="sidebar" class="sidebar">
    <div class="sidenav">
      <div class="sidenav-item">Page Content</div>
      <div class="sidenav-item">Media</div>

      <div class="sidenav-item">Profile</div>
    </div>
  </div>

  <div class="content">
    <form class="">
      <div class="title-bar">
        <h4 class=" text-center font-weight-bold mt-1">
          General Page Details
        </h4>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-2" for="heading">Page Heading:</label>
        <div class="col-sm-10">
          <textarea
            class="form-control"
            id="heading"
            placeholder="Page heading..."
            name="heading">{{pageContent.heading}}</textarea>
        </div>
      </div>
      <div class="form-group">
        <label class="control-label col-sm-2" for="subheading">Page Sub-Heading:</label>
        <div class="col-sm-10">
          <textarea
            class="form-control"
            id="subheading"
            placeholder="Page sub-heading..."
            name="subheading">{{pageContent.sub_heading}}</textarea>
        </div>
      </div>
      <div class="form-group">
        <label class="control-label col-sm-2" for="base_color">Main Color:</label>
        <div class="col-sm-10">
          <input
            class="form-control"
            type="color"
            id="base_color"
            name="base_color"
            value={{pageContent.base_color}}>
        </div>
      </div>
      <div class="form-group mt-2">
        <div class="col-sm-offset-2 col-sm-10">
          <button type="submit" class="btn btn-default">Submit</button>
        </div>
      </div>
    </form>

  </div>
</div>
